function e(e,p,o,t){if(!(typeof o===t))throw new TypeError(`Invalid prop '${p}' of type '${typeof o}' supplied to '${e}', expected '${t}'.`)}export{e as default};
